import React from 'react';

import { Intro } from '@edx/components/typography';
import { Button } from '@edx/components/button';

type Props = {
  headline?: string;
  dismissButtonText?: string;
  primaryButtonText?: string;
  onPrimaryButtonClick?: () => void;
  onDismiss?: () => void;
  variant?: 'invertedButtonsColors' | 'invertedButtonsOrder';
  children?: React.ReactNode;
};

export const Modal = React.forwardRef<HTMLDivElement, Props>(
  (
    { headline, dismissButtonText = 'Cancelar', primaryButtonText, onPrimaryButtonClick, onDismiss, variant, children },
    ref
  ) => {
    const showButtons = Boolean(primaryButtonText && onPrimaryButtonClick);

    return (
      <div className="fixed z-50 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-800 opacity-80" />
          </div>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>

          <div
            className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full p-6"
            role="dialog"
            aria-modal="true"
            {...(headline && { 'aria-labelledby': 'modal-headline' })}
            ref={ref}
          >
            <div className="flex">
              <div className="text-left">
                {headline && (
                  <Intro id="modal-headline" tag="h3" size="small" className="mb-2 leading-6 text-gray-900">
                    {headline}
                  </Intro>
                )}

                {children && <div className="my-4">{children}</div>}
              </div>
            </div>

            {showButtons && (
              <div className="mt-5 sm:mt-4 flex space-x-2">
                <Button
                  className={variant === 'invertedButtonsOrder' ? 'order-2' : 'order-1'}
                  variant={variant === 'invertedButtonsColors' ? 'primary' : 'outlineLight'}
                  onClick={onDismiss}
                >
                  {dismissButtonText}
                </Button>

                <Button
                  className={variant === 'invertedButtonsOrder' ? 'order-1' : 'order-2'}
                  variant={variant === 'invertedButtonsColors' ? 'outlineLight' : 'primary'}
                  onClick={onPrimaryButtonClick}
                >
                  {primaryButtonText}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);
